module.exports = __webpack_public_path__ + "img/socialLink.ccb6a77a.svg";